import styled from 'styled-components';
import RewardBonusSmallSvg from '../../assets/wallet/ic-reward-small.svg';

const RewardBonusSmallIcon = styled(RewardBonusSmallSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
    width: ${props => props.width || '1.6rem'};
    height: ${props => props.height || '1.6rem'};
`;

export default RewardBonusSmallIcon;
